import { MenuItem, Select, SelectChangeEvent } from "@mui/material";
import React from "react"
import { PersonaType } from "../../models";

interface PersonaTypeSelectProps {
  value: PersonaType;
  onChange: (event: SelectChangeEvent<PersonaType>) => void;
}

export const PersonaTypeSelect: React.FC<PersonaTypeSelectProps> = ({
  value,
  onChange,
}) => {

  return (
    <Select
      value={value}
      onChange={onChange}
      label="Type"
      name="type"
    >
      <MenuItem value={"default"}>Default</MenuItem>
      <MenuItem value={"reel"}>Reel</MenuItem>
      <MenuItem value={"gmail"}>Gmail</MenuItem>
      <MenuItem value={"music"}>Music</MenuItem>
      <MenuItem value={"article"}>Article</MenuItem>
      <MenuItem value={"video"}>Video</MenuItem>
      <MenuItem value={"streamer"}>Streamer</MenuItem>
    </Select>
  )
}
